export const dateWithoutTimezone = (value: string) => {
  const date = new Date(value);
  const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  return new Date(date.valueOf() - tzoffset).toISOString().slice(0, -1);
};
